import { defineQuery } from 'next-sanity'

export const locationSearchFields = `
  _id,
  _type,
  title,
  subtitle,
  backgroundColor
`

export const LOCATION_SEARCH_QUERY = defineQuery(/* groq */ `
  *[_type == "location-search"][0]{
    ${locationSearchFields}
  }
`)
